export type { UploadExcelProps } from './upload-excel';
export * from './upload-excel.routes';

export { default as UploadExcel, default } from './upload-excel';
